exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "td[data-v-56fe7bfd] {\n  max-width: 200px;\n  white-space: normal !important;\n}\n", ""]);

